import type { IChartDataSignal } from "../../interfaces";

const SYNCHRONIZED_RANGE_TYPE = 2;

export const getSignalMarkerPassageXValues = (series: IChartDataSignal): number[] => {
  if (series.rangeType !== SYNCHRONIZED_RANGE_TYPE || series.items.length === 0) {
    return [];
  }

  const xStart = series.items[0]?.x;
  const xEnd = series.items[series.items.length - 1]?.x;

  if (
    typeof xStart !== "number" ||
    !Number.isFinite(xStart) ||
    typeof xEnd !== "number" ||
    !Number.isFinite(xEnd) ||
    xEnd <= xStart
  ) {
    return [];
  }

  const firstMarkerX = Math.ceil(xStart);
  const markerCount = Math.min(Math.ceil(xEnd - firstMarkerX), series.items.length);

  return Array.from({ length: markerCount }, (_, index) => firstMarkerX + index);
};
